import React, { useEffect } from 'react';
import '../styles/onboard.css';
import OnboardLeftSection from '../components/OnboardLeftSection';
import { FaEnvelope } from 'react-icons/fa';

/**
 * VerifyEmail - Simplified email verification waiting page
 *
 * This page displays after signup and shows instructions to check email.
 * - Clears localStorage on mount
 * - Redirects to Landing on refresh/back navigation
 * - No auto-sign-in behavior
 * - No resend button (simplified flow)
 * - User must click the email link to verify, then manually sign in
 */
function VerifyEmail({ onNavigateToLanding, userEmail }) {
    // Clear localStorage and redirect to Landing on mount (handles refresh/back)
    useEffect(() => {
        // Clear any verification flags
        localStorage.removeItem('email_verification_in_progress');

        // Check if this is a refresh or back navigation by checking sessionStorage
        const isInitialLoad = !sessionStorage.getItem('verify_email_visited');

        if (isInitialLoad) {
            // First time visiting VerifyEmail - set the flag
            sessionStorage.setItem('verify_email_visited', 'true');
        } else {
            // User refreshed or navigated back - redirect to Landing
            console.log('VerifyEmail: Detected refresh or back navigation, redirecting to Landing');
            if (onNavigateToLanding) {
                onNavigateToLanding();
            }
        }

        // Cleanup on unmount
        return () => {
            sessionStorage.removeItem('verify_email_visited');
        };
    }, [onNavigateToLanding]);

    return (
        <div className="onboard-container signin-container">
            <div className="signin-layout">
                <OnboardLeftSection
                    onClose={onNavigateToLanding}
                    loading={false}
                    mode="verifyEmail"
                />

                <div className="signin-content">
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            margin: '0 auto 20px',
                            background: 'transparent',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '40px',
                            border: 'none'
                        }}>
                            <FaEnvelope style={{ color: '#000000', fontSize: '40px' }} />
                        </div>
                    </div>

                    <h1>Verify Your Email</h1>
                    <p className="signin-subtitle">
                        We sent a verification link to{' '}
                        <strong>{userEmail || 'your email'}</strong>.
                    </p>

                    <p className="signin-subtitle" style={{ marginTop: '20px' }}>
                        Please check your inbox and click the link to verify your account.
                    </p>

                    <div style={{
                        marginTop: '30px',
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        textAlign: 'left'
                    }}>
                        <h3 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            marginBottom: '15px',
                            color: '#333'
                        }}>
                            Next Steps:
                        </h3>
                        <ol style={{
                            margin: '0',
                            paddingLeft: '20px',
                            color: '#666',
                            fontSize: '14px',
                            lineHeight: '1.8'
                        }}>
                            <li>Check your email inbox (and spam folder)</li>
                            <li>Click the verification link in the email</li>
                            <li>You'll be redirected to a confirmation page</li>
                            <li>Sign in with your email and password</li>
                        </ol>
                    </div>

                    <div className="signin-footer" style={{ marginTop: '30px' }}>
                        <p style={{ fontSize: '13px', color: '#999' }}>
                            You can close this page. The verification link will work from your email.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerifyEmail;
